import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import { useNavigate } from 'react-router-dom';

const TrainingIncentive = () => {
        const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Training Incentives"));
  }, []);

  const [trainingData, setTrainingData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    ProjectID: { text: "Project", visible: true },
    Client: { text: "Client", visible: true },
    FromDate: { text: "From", align: "center", visible: true },
    ToDate: { text: "To", align: "center", visible: true },
    TrainingType: { text: "Type", align: "center", visible: true },
    AmountPerDay: { text: "STD.Rate", align: "center", visible: true },
    AppliedPerDayAmount: { text: "App Rate", align: "center", visible: true },
    Days: { text: "#Days", align: "center", visible: true },
    IsIncludeHoliday: { text: "Include Holiday", align: "center", visible: true },
    TotatAmountApplied: { text: "Total", align: "center", visible: true },
  };

  const fetchTrainingIncentive = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/project-training`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const expenseData = response?.data?.data;
        console.log("expenseData", expenseData);
        setTrainingData(expenseData);
      } else {
        console.error(
          "Failed to fetch Training Incentive. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Training:", error);
    }
  };

  useEffect(() => {
    fetchTrainingIncentive();
  }, []);

  const handleAddNewTraining = () =>{
    navigate(`/training-incentive/add`)
  }

  const handleEdit = (item) =>{
    navigate(`/training-incentive/edit/${item.ID}`)
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={trainingData}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              showIcon1={true}
              searchTerm={searchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              setSearchTerm={setSearchTerm}
              isAddNewBtnRequired={true}
              isActionRequired={true}
              handleAddNew={handleAddNewTraining}
              handleIcon1={handleEdit}
              icons={{
                Icon1: <i class="bi bi-pencil-square"></i>,
                Icon1Text:'Edit',
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TrainingIncentive;
